export const TRANSLATION_NAMESPACE = 'registration';
